<template>
    <div class="amazonProductCount-container">
        <div class="select-box">
            <div class="select-item">
                <div class="label">时间</div>
                <el-date-picker v-model="startDate" type="date" style="width:100%" value-format="yyyy-MM-dd" />
            </div>
            <div class="select-item">
                <div class="label">至</div>
                <el-date-picker v-model="endDate" type="date" style="width:100%" value-format="yyyy-MM-dd" />
            </div>
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="exportData" type="primary">导出</el-button>
        </div>
        <el-table :data="tableData" border stripe  style="width:100%;" height="720px">
            <el-table-column label="店铺名" prop="shopName" width="200" align="center" />
            <el-table-column label="国家" prop="countryCode" width="80" align="center" />
            <el-table-column label="时区" prop="timezone" width="200" align="center" />
            <el-table-column label="数据日期" prop="dataDate" align="center" width="100" />
            <el-table-column label="广告活动名称" prop="campaignName" align="center" width="300" />
            <el-table-column label="状态" prop="campaignStatus" align="center" />
            <el-table-column label="投放策略" prop="campaignBiddingStrategy" align="center" width="120" />
            <el-table-column label="预算金额" prop="campaignBudgetAmount" align="center">
                <template slot-scope="{row}">
                    {{ row.campaignBudgetAmount !== null && row.campaignBudgetAmount !== undefined ? row.campaignBudgetAmount : 0 }}
                </template>
            </el-table-column>
            <el-table-column label="预算币种" prop="campaignBudgetCurrencyCode" align="center" />
            <el-table-column label="曝光量" prop="impressions" align="center" />
            <el-table-column label="点击量" prop="clicks" align="center" />
            <el-table-column label="点击率" prop="clickThroughRate" align="center">
                <template slot-scope="{row}">
                    {{ row.clickThroughRate ? (row.clickThroughRate * 100).toFixed(2) + '%' : '0.00%' }}
                </template>
            </el-table-column>
            <el-table-column label="花费" prop="cost" align="center">
                <template slot-scope="{row}">
                    {{ row.cost ? Number(row.cost).toFixed(2) : '0.00' }}
                </template>
            </el-table-column>
            <el-table-column label="CPC" prop="costPerClick" align="center">
                <template slot-scope="{row}">
                    {{ row.costPerClick ? Number(row.costPerClick).toFixed(2) : '0.00' }}
                </template>
            </el-table-column>
            <el-table-column label="14天购买" prop="purchases14d" align="center" />
            <el-table-column label="14天销售额" prop="sales14d" align="center">
                <template slot-scope="{row}">
                    {{ row.sales14d ? Number(row.sales14d).toFixed(2) : '0.00' }}
                </template>
            </el-table-column>
            <el-table-column label="ACOS" prop="acosClicks14d" align="center">
                <template slot-scope="{row}">
                    {{ row.acosClicks14d ? (row.acosClicks14d * 100).toFixed(2) + '%' : '0.00%' }}
                </template>
            </el-table-column>
            <el-table-column label="ROAS" prop="roasClicks14d" align="center">
                <template slot-scope="{row}">
                    {{ row.roasClicks14d ? Number(row.roasClicks14d).toFixed(2) : '0.00' }}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pagination-center" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total" />
    </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import axios from "axios";
export default {
    name: 'amazonProductCount',
    components: {},
    props: {},
    data() {
        return {
            shopIds: [],
            startDate: "",
            endDate: "",
            activeName: 'total',
            tableData: [],
            pageNum: 1,
            pageSize: 20,
            total: 0,
            exportLoading: false,
        };
    },
    created() {
        const sellerInfoText = localStorage.getItem('sellerInfo');
        if (sellerInfoText) {
            const sellerInfo = JSON.parse(sellerInfoText);
            this.shopIds = sellerInfo.shopIds;
        }
        if (!this.shopIds.length) {
            this.$message.error("请绑定店铺！");
            return
        }
        const yesterday = this.getYesterdayDate();
        this.startDate = yesterday;
        this.endDate = yesterday;
        this.getDetailData();//获取汇总数据
    },
    mounted() { },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.getDetailData()
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.getDetailData()
        },
        getYesterdayDate() {
            const date = new Date();
            date.setDate(date.getDate() - 1);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        search() {
            this.tableData = [];
            this.getDetailData();//获取明细数据
        },
        getDetailData() {
            const params = {
                shopIds: this.shopIds,
                startDate: this.startDate,
                endDate: this.endDate,
                page: this.pageNum,
                pageSize: this.pageSize,
            }
            ajaxPost(Baseurl + "amazonAdsController/getList", params).then(res => {
                if (res.data.code === 200) {
                    const data = res.data.data;
                    this.total = data.total;
                    this.tableData = data.list;
                }
            })
        },
        exportData() {
            const params = {
                startDate: this.startDate,
                endDate: this.endDate,
                shopIds: this.shopIds
            }
            const url = Baseurl + 'amazonAdsController/export';
            this.exportLoading = true;

            axios({
                url: url,
                method: 'post',
                data: params,
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'blob',
                timeout: 600000
            }).then(res => {

                let blob = new Blob(
                    [res.data],
                    {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                );

                let link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);

                link.download = '亚马逊广告.xlsx';

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);

                window.URL.revokeObjectURL(link.href);

            }).catch(() => {

                this.$message.error('导出失败');

            }).finally(() => {

                this.exportLoading = false;

            });
        }
    },
};
</script>
<style lang="scss" scoped>
.amazonProductCount-container{
    .select-box {
        display: flex;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;

        .select-item {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .label {
                width: 40px;
            }
        }
    }
    /deep/ .pagination-center {
        display: flex;
        justify-content: center;
        margin-top: 16px;
        // 可选上下间距微调
        margin-bottom: 8px;

        // Element分页内部元素间距优化
        /deep/ .el-pagination {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
    }
}

</style>